import {Box} from '@mantine/core';
import type {FC} from 'react';

/**
 * Grey, rounded, bordered panel used to visually group secondary content.
 * @registry Grey bordered panel, sm/lg spacing presets.
 *
 * Ported from `library/forms/FormSecondaryPanel`. Renamed
 * `FormSecondaryPanel` -> `SecondaryPanel`. Prop surface kept identical.
 * Hex colors kept as literals — no matching `design/tokens` constants exist
 * yet (see `tokens/README.md`).
 */
export interface SecondaryPanelProps {
  children?: React.ReactNode;
  spacing?: 'sm' | 'lg';
}

export const SecondaryPanel: FC<SecondaryPanelProps> = ({
  children,
  spacing = 'lg',
}) => {
  return (
    <Box
      p={spacing == 'lg' ? 'md' : 'xs'}
      mb={spacing == 'lg' ? 'md' : 0}
      style={{
        backgroundColor: '#f2f2f2',
        borderRadius: '0.25rem',
        border: '1px solid',
        borderColor: '#cfcece',
        boxSizing: 'border-box',
      }}>
      {children}
    </Box>
  );
};
